import { useFetchNextPageQuery } from 'hooks'
import {
  PublicExpertDetailConsultationTabDocument,
  type PublicExpertDetailConsultationTabQuery,
  type PublicExpertDetailConsultationTabQueryVariables,
} from 'types/graphql-generated'

export const EXPERT_REVIEWS_LIMIT = 4

export const usePublicExpertDetailConsultationTab = ({
  slug,
  reviewsInput = {},
}: PublicExpertDetailConsultationTabQueryVariables) => {
  const { data, loading, fetchNextPage } = useFetchNextPageQuery<
    PublicExpertDetailConsultationTabQuery,
    PublicExpertDetailConsultationTabQueryVariables
  >(PublicExpertDetailConsultationTabDocument, {
    fetchPolicy: 'cache-first',
    pageSize: EXPERT_REVIEWS_LIMIT,
    variablesFactory: ({ page, limit }) => ({
      slug,
      reviewsInput: {
        ...reviewsInput,
        isPublicVisible: true,
        pagination: {
          page,
          limit,
        },
      },
    }),
  })

  const nextPage = data?.expertBySlug?.reviews?.paginationInfo?.nextPage

  return {
    expert: data?.expertBySlug,
    nextPage,
    loading,
    fetchNextPage,
  }
}
